import React from "react";

import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import PropTypes from "prop-types";

export const placeholderTypes = Object.freeze({
  events: "placeholder-events",
  news: "placeholder-news",
});

const ImagePlaceholder = ({
  aspectRatio = 1,
  className = "",
  height = null,
  typ = null,
  width = 1920,
  objectFit = "contain",
}) => {
  const imageName = placeholderTypes[typ] || "placeholder";

  const data = useStaticQuery(graphql`{
    placeholderImages: allFile(filter: {name: {regex: "/placeholder/"}}) {
      nodes {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
        }
        name
      }
    }
  }`);

  const imageNode = data?.placeholderImages?.nodes.find((item) => item.name === imageName);

  if (!imageNode?.childImageSharp?.gatsbyImageData) {
    return null;
  }

  const image = {
    ...imageNode.childImageSharp.gatsbyImageData,
    height: height > 0 ? height : width / aspectRatio,
    width: width > 0 ? width : height / aspectRatio,
  };

  return (
    <div className="p-absolute w-100 h-100">
      <GatsbyImage image={image} alt="Placeholder" className={`p-absolute w-100 h-100 ${className}`} objectPosition="50%" objectFit={objectFit} />
    </div>
  );
};

ImagePlaceholder.propTypes = {
  aspectRatio: PropTypes.number,
  className: PropTypes.string,
  height: PropTypes.number,
  objectFit: PropTypes.oneOf(["contain", "cover"]),
  typ: PropTypes.oneOf(["events", "news"]),
  width: PropTypes.number,
};

export default ImagePlaceholder;
